import React from "react";
import TrustSmall from "@/components/layouts/TrustSmall";
import {SbBlokData, storyblokEditable} from "@storyblok/react";
import { AccreditationSmallSection, HeroAnimated } from "@/.storyblok/types/319751/storyblok-components";
import Image from "next/image";
import Link from "next/link";

interface HeroProps {
  blok?: HeroAnimated & SbBlokData;
  trustSmall?: AccreditationSmallSection & SbBlokData;
}

const HeroAnimatedComponent: React.FC<HeroProps> = ({ blok, trustSmall }) => {
  if (!blok) return null;

  const { title, subtitle, description, image, cta_button, cta_button_link, trust_small_label } =
    blok;

  const h1Content = (
    <>
      {title && (
        <>
          <span>{title}<span>&nbsp;</span></span>
        </>
      )}
      {subtitle && <span>{subtitle}</span>}
    </>
  );

  const renderLink = (
    cta_button_link: HeroAnimated["cta_button_link"] | undefined,
  ) => {
    return cta_button_link?.cached_url || "#"; // Fallback to "#" if no valid link
  };

  const renderImage = (image: HeroAnimated["image"] | undefined) => {
    return image?.filename || "";
  };

  return (
    <>
      <div {...storyblokEditable(blok)} className="page-hero scroll-trigger on">
        <div className="container">
          <div className="row">
            <div className="col-24 col-lg-16 page-hero-content pt-4 pb-6 py-lg-6 py-xl-7">
              <h1 style={{ textRendering: 'optimizeSpeed' }}>{h1Content}</h1>
              {description && (
                <p className="page-hero-subtitle mb-4">{description}</p>
              )}
              {cta_button && (
                <Link
                  href={renderLink(cta_button_link)}
                  className="btn btn-primary btn-lg"
                >
                  {cta_button}
                </Link>
              )}
            </div>
          </div>
        </div>
        {image && image.filename && (
          <picture>
            <Image
              src={renderImage(image)}
              alt={image.alt || "Hero image"}
              className="page-hero-img scroll-trigger fade-in duration-2s img-blur-bg on"
              width={1680}
              height={945}
              sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
              loading="eager"
              quality={75}
            />
          </picture>
        )}
      </div>
      {trustSmall && <TrustSmall blok={trustSmall}  title={trust_small_label} />}
    </>
  );
};

export default HeroAnimatedComponent;